import commonMapping from "@/mapping/common";

const rip_direction_list = [
  { config: "both", value: "Both", label: "rip_both" },
  { config: "in_only", value: "In only", label: "rip_in" },
  { config: "out_only", value: "Out only", label: "rip_out" },
];

const rip_version_list = [
  { config: "disabled", value: "Disabled", label: "rip_disable" },
  { config: "rip1", value: "RIP_1", label: "rip1" },
  { config: "rip2b", value: "RIP_2B", label: "rip2b" },
  { config: "rip2m", value: "RIP_2M", label: "rip2m" },
];

const rip_auth_list = [
  { config: "no_auth", value: "no_auth", label: "No authentication" },
  { config: "text", value: "text", label: "text_mark" },
  { config: "md5", value: "md5", label: "md5_mark" },
];

export const lan = {
  dhcp_enable: commonMapping.intToBoolean,
  rip_direction: rip_direction_list,
  rip_version: rip_version_list,
  rip_auth: rip_auth_list,
};

export default lan;
